import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ProductsPage } from './pages/ProductsPage';
import { ThemesPage } from './pages/ThemesPage';
import { AppsPage } from './pages/AppsPage';
import { PortfolioPage } from './pages/PortfolioPage';
import { TeamPage } from './pages/TeamPage';
import { ContactPage } from './pages/ContactPage';
import { FlowBoostPage } from './pages/FlowBoostPage';
import { AIPhotoshootPage } from './pages/AIPhotoshootPage';
import { PrivacyPolicyPage, TermsPage, RefundPolicyPage, CookiesPolicyPage } from './pages/LegalPages';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<AboutPage data-id="element-6" />} data-id="element-5" />
          <Route path="/services" element={<ServicesPage data-id="element-8" />} data-id="element-7" />
          <Route path="/products" element={<ProductsPage data-id="element-10" />} data-id="element-9" />
          <Route path="/themes" element={<ThemesPage data-id="element-12" />} data-id="element-11" />
          <Route path="/apps" element={<AppsPage data-id="element-14" />} data-id="element-13" />
          <Route path="/portfolio" element={<PortfolioPage data-id="element-16" />} data-id="element-15" />
          <Route path="/team" element={<TeamPage data-id="element-18" />} data-id="element-17" />
          <Route path="/contact" element={<ContactPage data-id="element-20" />} data-id="element-19" />
          <Route path="/flowboost" element={<FlowBoostPage data-id="element-22" />} data-id="element-21" />
          <Route path="/ai-photoshoot" element={<AIPhotoshootPage data-id="element-24" />} data-id="element-23" />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-26" />} data-id="element-25" />
          <Route path="/terms" element={<TermsPage data-id="element-28" />} data-id="element-27" />
          <Route path="/refund-policy" element={<RefundPolicyPage data-id="element-30" />} data-id="element-29" />
          <Route path="/cookies-policy" element={<CookiesPolicyPage data-id="element-32" />} data-id="element-31" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}